import { ok } from 'assert'
import { ChannelCredentials, GrpcObject, ServiceClientConstructor, credentials, loadPackageDefinition } from "@grpc/grpc-js";
import { loadProto } from "./tools.ts";
import pluginManage from './plugin.ts';

export type ClientOptions = {
    host: string,
    path: string,
    package: string,
    service: string,
    interfaces: Array<string>,
    credentials?: ChannelCredentials,
}


export type ClientFunction = (message: Record<any, any>) => Promise<void>

export type ClientInstance = { [key: string]: ClientFunction | any }


const isNull = (value: any): boolean => value === null || value === undefined
const callbackToPromise = () => {

}


export default <M extends ClientInstance>(options: ClientOptions): M => {
    const definition = loadProto(options.path);
    ok(!isNull(definition), `加载 ${options.path} 出错！`)
    const grpcObject: GrpcObject = loadPackageDefinition(definition);
    ok(!isNull(grpcObject), `加载 ${options.path} 出错！`)
    const grpcPackage = grpcObject[options.package]
    ok(!isNull(grpcPackage), `package ${options.package} 不存在！`)
    const ClientConstructor = (grpcPackage[options.service] as ServiceClientConstructor);
    ok(!isNull(grpcPackage), `service ${options.service} 不存在！`)
    const grpcClient = new ClientConstructor(options.host, options.credentials ?? credentials.createInsecure()) as unknown as M;

    const client: M = new Proxy(grpcClient, {
        get: (target, propKey, receiver) => {
            let value = Reflect.get(target, propKey, receiver);
            if (typeof value !== 'function' || !options.interfaces.includes(String(propKey))) {
                return value;
            }
            const call = value as Function

            const run = (params: any): Promise<any> => {
                return new Promise((reslove, reject) => {
                    const callback = (err, response) => err ? reject(err) : reslove(response)
                    call.apply(grpcClient, [params, callback]);
                })
            }

            return (args: any) => pluginManage.callClientMiddleware(args, run)
        }
    });

    return client;
}